import { create } from 'zustand'

export type ConnectionStatus = 'idle' | 'signaling' | 'connecting' | 'connected' | 'failed' | 'closed'

export interface SessionState {
  status: ConnectionStatus
  error: string | null
  roomCode: string | null
  shareLink: string | null
  selfId: string | null
  opponentId: string | null
  setStatus(status: ConnectionStatus, error?: string | null): void
  setRoom(patch: { roomCode?: string | null; shareLink?: string | null }): void
  setPeers(selfId: string | null, opponentId?: string | null): void
  reset(): void
}

const initialState = {
  status: 'idle',
  error: null,
  roomCode: null,
  shareLink: null,
  selfId: null,
  opponentId: null,
} satisfies Omit<SessionState, 'setStatus' | 'setRoom' | 'setPeers' | 'reset'>

/** 只放会话/连接 UI 状态；对局状态由房间层 reducer 持有，绝不进这里 */
export const useSession = create<SessionState>()((set) => ({
  ...initialState,
  setStatus: (status, error = null) => set({ status, error }),
  setRoom: (patch) =>
    set((state) => ({
      roomCode: patch.roomCode === undefined ? state.roomCode : patch.roomCode,
      shareLink: patch.shareLink === undefined ? state.shareLink : patch.shareLink,
    })),
  setPeers: (selfId, opponentId = null) => set({ selfId, opponentId }),
  reset: () => set({ ...initialState }),
}))
